<template>
    <segment collapsable title="Platform Settings">
      <div>
        <radio-group inline label="Badges" v-model="badges" :options="[{ text: 'Don\'t Set', value: 'dontSet'}, { text: 'Set to', value: 'setTo'}]" />
        <input-group inline label="Badge Count" v-model="badgeCount" value-type="number" :min="0" :disabled="badges === 'dontSet'" />
        <input-group inline placeholder="'default' for default ringtone, (filename.extension) for specific tones" label="Sound" v-model="sound" />
        <div style="display: flex; align-items: center;">
          <a target="_blank" href="https://developer.apple.com/documentation/usernotifications/modifying_content_in_newly_delivered_notifications" style="margin-right: 15px;">
            <i class="fas fa-info-circle" />
           </a>
          <radio-group inline label="Mutable Content" v-model="mutableContent" :options="[{ text: 'Yes', value: 'true' }, { text: 'No', value: 'false' }]" />
        </div>
      </div>
    </segment>
</template>

<script>
import Segment from "@/views/PushNotification/UIComponents/Segment";
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import RadioGroup from "@/views/PushNotification/UIComponents/RadioGroup";

export default {
  name: "PlatformSettings",
  components: {
    Segment,
    InputGroup,
    RadioGroup
  },
  model: {
    prop: "modelProp",
    event: "modelEvent"
  },
  props: {
    modelProp: Object,
  },
  computed: {
    mutableContent: {
      get() {
        const value = this.modelProp.mutableContent;
        // Handle string values explicitly
        if (value === 'true') return 'true';
        if (value === 'false') return 'false';
        // For actual boolean values
        return value ? 'true' : 'false';
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, mutableContent: value === 'true' });
      }
    },
    badges: {
      get() {
        return this.modelProp.badges;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, badges: value });
      }
    },
    badgeCount: {
      get() {
        return this.modelProp.badgeCount;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, badgeCount: value });
      }
    },
    sound: {
      get() {
        return this.modelProp.sound;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, sound: value });
      }
    }
  }
}
</script>

<style scoped>

</style>